import React from "react";
import { Link } from "react-router-dom";
import "./SiteMap.css"; 

const Sitemap = () => {
  return (
    <div className="sitemap">
      <ul className="sitemap_container">
        <li>
          <Link to="/aboutTema">about TEMA</Link>
        </li>
        <li>
          <Link to="/newBusinessDevelopment">new business development</Link>
          <ul className="sitemap_list">
            <li>
              <Link to="/newBusinessDevelopment/mercaway">MERCAWAY℠</Link>
              <ul className="sitemap_list">
                <li>
                  <Link to="/newBusinessDevelopment/mercaway/techadvantages">
                    tech advantages
                  </Link>
                </li>
                <li>
                  <Link to="/newBusinessDevelopment/mercaway/flowdiagram">
                    flow diagram
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li>
          <Link to="/contactUs">ContactUs</Link>
        </li>
      </ul>
    </div>
  );
};

export default Sitemap;